import http from '@/http'

export default {
  // 获取活动报名人数
  getActivityEnrollment: (params) =>
    http.get(`/activity/getActivityNumberById/${params}`, { isToken: false }),
}

